// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span.passage-underline{border-bottom:1px solid #000}", "",{"version":3,"sources":["webpack://./src/plugins/PassageUnderline/passageUnderline.css"],"names":[],"mappings":"AAAA,uBACE,4BACF","sourcesContent":["span.passage-underline {\r\n  border-bottom: 1px solid black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
